// extracted by mini-css-extract-plugin
module.exports = {"stylesButton":"pTM_uR78","stylesXsButton":"ChYsk_YY","styledDropdownMenu":"KxvcUzEA","select":"xEc0RQsN","selectWrapper":"A6eSljep","optionWrapper":"smiwypkl","label":"YdQjAnxn"};